import { ChatButton } from "./ChatButton";
import { useChatVisibility } from "@platform/hooks/useChatVisibility";
import { useChatUnreadCount } from "@core/features/chat";
import { useChatActions } from "@platform/hooks/useChat";
import { useUser } from "@platform/store";
import { useFetchUserCircles } from "@core/features/circle";

export type Props = {
  className?: string;
  containerClassName?: string;
  isChatDisabled?: boolean;
};

export function ChatButtonContainer({
  className,
  containerClassName,
  isChatDisabled,
}: Props) {
  const user = useUser();
  const { data: circlesData } = useFetchUserCircles({ user });
  const userCircles = circlesData?.circles ?? null;
  const { shouldShowChat, isLoading } = useChatVisibility({
    userCircles,
    isChatDisabled,
  });

  const unreadCount = useChatUnreadCount();
  const { openChat } = useChatActions();

  // Don't render chat button if chat is disabled or still loading
  if (isLoading || !shouldShowChat) {
    return null;
  }

  return (
    <ChatButton
      className={className}
      containerClassName={containerClassName}
      unreadCount={unreadCount}
      onClick={openChat}
    />
  );
}

export default ChatButtonContainer;


